require('./accountDebitsEditStep2.scss');

// @ vendors
const PureRenderMixin = require('react-addons-pure-render-mixin');
const PropTypes = require('prop-types');
const React = require('react');

// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING_WITH_SUMMARY,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');

// @ constants
const { ACCOUNT_DEBIT_EDIT } = require('constants/operationTypes');

class AccountDebitsEditStep2 extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render(){
        const {
            accountHolder,
            accountInfo,
            balance,
            newAccountHolder,
            newAccountInfo,
            newBalance,
            operationParams
        } = this.props;

        const operative = formatText('operatives-changeReceiptAccount');

        return (
            <section className="debits-edit-step2">
                <h2 className="debits-edit-step2__header">
                    <FormattedText value="debitsEdit-stepTwoTitle" />
                </h2>
                <ContactCenterRender>
                    <ConfirmationScript
                        operative={operative}
                        confirmationType={CONFIRMATION_SCRIPT_GREETING_WITH_SUMMARY}
                    />
                </ContactCenterRender>
                <div className="debits-edit-step2__content">
                    <h3 className="debits-edit-step2__subtitle no-print-out"><FormattedText value="debitsEdit-stepTwoSubTitle" /></h3>
                    <div className="debits-edit-step2__text">
                        <FormattedText value="debitsEdit-stepTwoDescription" />
                    </div>
                    <OKInformativeList columns={3} title="debitsEdit-originAccount">
                        <OKInformativeListItem
                            title={formatText('debitsEdit-beneficiary')}
                            bodyText={accountHolder}
                        />
                        <OKInformativeListItem
                            title={formatText('debitsEdit-accountName')}
                            bodyText={accountInfo}
                        />
                        <OKInformativeListItem
                            title={formatText('debitsEdit-balance')}
                            bodyText={balance}
                        />
                    </OKInformativeList>
                    <OKInformativeList columns={3} title="debitsEdit-destinationAccount">
                        <OKInformativeListItem
                            className="debits-edit-step2__bottom-row"
                            title={formatText('debitsEdit-beneficiary')}
                            bodyText={newAccountHolder}
                            bodyWordBreak={false}
                        />
                        <OKInformativeListItem
                            className="debits-edit-step2__bottom-row"
                            title={formatText('debitsEdit-accountName')}
                            bodyText={newAccountInfo}
                        />
                        <OKInformativeListItem
                            className="debits-edit-step2__bottom-row"
                            title={formatText('debitsEdit-balance')}
                            bodyText={newBalance}
                        />
                    </OKInformativeList>
                </div>
                <ContactCenterRender>
                    <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT}/>
                </ContactCenterRender>
                <SignaturePattern
                    operationType={ACCOUNT_DEBIT_EDIT}
                    operationParams={operationParams}
                />
            </section>
        );
    }
}

AccountDebitsEditStep2.propTypes = {
    accountHolder: PropTypes.string.isRequired,
    accountInfo: PropTypes.string.isRequired,
    balance: PropTypes.string.isRequired,
    newAccountHolder: PropTypes.string,
    newAccountInfo: PropTypes.string,
    newBalance: PropTypes.string,
    operationParams: PropTypes.object.isRequired
};

module.exports = AccountDebitsEditStep2;